jQuery(document).ready(function($) {
    $('a[data-rel^=lightcase]').lightcase({
        maxWidth: 1000,
        type: 'image',
        swipe: true,
    });
});



// WEBPACK FOOTER //
// ./scripts/plugins/lightcase.js